// ── Achievement images (28) ───────────────────────────────
import ThirdCoach from "images/Coach3Img.webp";
import ca1 from "images/CoachesAchivements/1.webp";
import ca2 from "images/CoachesAchivements/2.webp";
import ca3 from "images/CoachesAchivements/3.webp";
import ca4 from "images/CoachesAchivements/4.webp";
import ca5 from "images/CoachesAchivements/5.webp";
import ca6 from "images/CoachesAchivements/6.webp";
import ca7 from "images/CoachesAchivements/7.webp";
import ca8 from "images/CoachesAchivements/8.webp";
import ca9 from "images/CoachesAchivements/9.webp";
import ca10 from "images/CoachesAchivements/10.webp";
import ca11 from "images/CoachesAchivements/11.webp";
import ca12 from "images/CoachesAchivements/12.webp";
import ca13 from "images/CoachesAchivements/13.webp";
import ca14 from "images/CoachesAchivements/14.webp";
import ca15 from "images/CoachesAchivements/15.webp";
import ca16 from "images/CoachesAchivements/16.webp";
import ca17 from "images/CoachesAchivements/17.webp";
import ca18 from "images/CoachesAchivements/18.webp";
import ca19 from "images/CoachesAchivements/19.webp";
import "./CoachesAchievements.scss";
import Modal from "react-modal";
import { useState } from "react";
import VectorUnderline from "pages/Components/VectorUnderline/VectorUnderline";

type BadgeType = "gold" | "silver" | "record";

interface IAchievement {
  type: BadgeType;
  label: string;
  competition: string;
  detail: string;
}

const achievements: IAchievement[] = [
  {
    type: "record",
    label: "2× Rekord Europy",
    competition: "Federacja XPC",
    detail: "Przysiady i Total — kat. 67,5 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal",
    competition: "Mistrzostwa Europy XPC",
    detail: "Kat. 67,5 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal",
    competition: "Mistrzostwa Europy WRPF",
    detail: "Kat. 67,5 kg",
  },
  {
    type: "silver",
    label: "Srebrny Medal",
    competition: "Mistrzostwa Polski XPC",
    detail: "Kat. 75 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal",
    competition: "Mistrzostwa Europy XPC",
    detail: "Kat. 52 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal — Debiuty",
    competition: "Mistrzostwa Europy XPC",
    detail: "Kategoria debiutantów",
  },
  {
    type: "gold",
    label: "Złoty Medal — Open",
    competition: "Mistrzostwa Europy XPC",
    detail: "Największy ciężar względem masy ciała",
  },
  // ── Listopad 2023 — Mistrzostwa Europy WPA (Push & Pull + Martwy ciąg) ──
  {
    type: "record",
    label: "Rekord Europy",
    competition: "Federacja WPA",
    detail:
      "Push & pull i martwy ciąg — 97,5 kg wyciskanie, 210 kg martwy ciąg przy wadze 73,3 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal — Push & Pull",
    competition: "Mistrzostwa Europy WPA",
    detail: "Kat. T13-19 Open",
  },
  {
    type: "gold",
    label: "Złoty Medal — Push & Pull",
    competition: "Mistrzostwa Europy WPA",
    detail: "Kat. T13-15 do 75 kg",
  },
  {
    type: "gold",
    label: "Złoty Medal — Martwy ciąg",
    competition: "Mistrzostwa Europy WPA",
    detail: "Kat. T13-15 do 75 kg",
  },
  // ── Marzec 2025 — Mistrzostwa Europy XPC (Trójbój siłowy) ──
  {
    type: "gold",
    label: "Złoty Medal — Trójbój klasyczny",
    competition: "Mistrzostwa Europy XPC",
    detail:
      "Kat. 16-17 Open — 210 kg przysiad, 110 kg wyciskanie, 230 kg martwy ciąg",
  },
  {
    type: "gold",
    label: "Złoty Medal — Trójbój klasyczny",
    competition: "Mistrzostwa Europy XPC",
    detail: "Kat. 16-17 do 75 kg",
  },
];

const photos = [
  ca1,
  ca2,
  ca3,
  ca4,
  ca5,
  ca6,
  ca7,
  ca8,
  ca9,
  ca10,
  ca11,
  ca12,
  ca13,
  ca14,
  ca15,
  ca16,
  ca17,
  ca18,
  ca19,
];

const badgeLabel: Record<BadgeType, string> = {
  gold: "🥇 Złoto",
  silver: "🥈 Srebro",
  record: "🏆 Rekord",
};

const CoachesAchievements = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const goPrev = () =>
    setOpenIdx((i) =>
      i !== null ? (i - 1 + photos.length) % photos.length : 0,
    );
  const goNext = () =>
    setOpenIdx((i) => (i !== null ? (i + 1) % photos.length : 0));

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "ArrowLeft") goPrev();
    if (e.key === "ArrowRight") goNext();
    if (e.key === "Escape") setOpenIdx(null);
  };

  return (
    <section className="achievementsPage">
      {/* ── Hero ─────────────────────────────────────── */}
      <section className="achievementsHero">
        <div className="achievementsHeroInner">
          <div className="achievementsEyebrow">Centrum Siły</div>
          <h1 className="achievementsTitle">
            Sukcesy naszych
            <span className="achievementsRed"> trenerów</span>
          </h1>
          <VectorUnderline noLeft />
          <p className="achievementsDesc">
            Poniższe wyniki zostały osiągnięte przez zawodników trenujących pod
            okiem naszego trenera — <strong>Andrzeja Dziedzica</strong>. To
            właśnie jego wiedza, metodyka i zaangażowanie przełożyły się na
            medale mistrzostw Europy i rekordowe wyniki w trójboju siłowym.
          </p>

          <div className="achievementsCoachCards">
            {/* ── Andrzej Dziedzic ── */}
            <div className="achievementsCoachCard">
              <div className="achievementsCoachCardImgWrapper">
                <img
                  src={ThirdCoach}
                  alt="Andrzej Dziedzic"
                  className="achievementsCoachCardImg"
                />
              </div>
              <div className="achievementsCoachCardBody">
                <div className="achievementsCoachCardName">
                  Andrzej Dziedzic
                </div>
                <div className="achievementsCoachCardSpecialty">
                  Trójbój siłowy · Trener
                </div>
                <div className="achievementsCoachCardDivider" />
                <div className="achievementsCoachCardTraineesLabel">
                  Podopieczni:
                </div>
                <ul className="achievementsCoachCardTrainees">
                  <li>Edyta Jędrzejczyk</li>
                  <li>Mikołaj Kiełbasa</li>
                  <li>Maciej Kiełbasa</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Achievement cards ────────────────────────── */}
      <section className="achievementsCardsSection">
        <div className="achievementsCardsInner">
          <h2 className="achievementsSectionTitle">
            Najważniejsze osiągnięcia
          </h2>
          <div className="achievementsCardsGrid">
            {achievements.map((a, i) => (
              <div
                key={i}
                className={`achievementCard achievementCard--${a.type}`}>
                <div className="achievementCardBadge">{badgeLabel[a.type]}</div>
                <div className="achievementCardLabel">{a.label}</div>
                <div className="achievementCardCompetition">
                  {a.competition}
                </div>
                <div className="achievementCardDetail">{a.detail}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Photo grid ───────────────────────────────── */}
      <section className="achievementsPhotosSection">
        <div className="achievementsPhotosInner">
          <h2 className="achievementsSectionTitle">Zdjęcia z zawodów</h2>
          <p className="achievementsPhotosDesc">
            Chwile zapisane na zawodach krajowych i europejskich.
          </p>
          <div className="achievementsPhotoGrid">
            {photos.map((src, i) => (
              <div
                key={i}
                className="achievementsPhotoItem"
                onClick={() => setOpenIdx(i)}>
                <img
                  src={src}
                  alt={`Osiągnięcia trenerów — zdjęcie ${i + 1}`}
                  loading="lazy"
                  className="achievementsPhotoImg"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ──────────────────────────────────────── */}
      <section className="achievementsCta">
        <div className="achievementsCtaInner">
          <div className="achievementsCtaBadge">Trenuj z mistrzami</div>
          <h2 className="achievementsCtaTitle">
            Chcesz osiągać podobne wyniki?
          </h2>
          <p className="achievementsCtaDesc">
            Nasi trenerzy połączą swoje doświadczenie zawodnicze z indywidualnym
            podejściem do każdego podopiecznego. Niezależnie od twojego poziomu
            — pomogą Ci świadomie i bezpiecznie rozwijać siłę.
          </p>
          <div className="achievementsCtaCards">
            <a href="tel:537240394" className="achievementsCtaContact">
              <span className="achievementsCtaContactName">Trener Andrzej</span>
              <span className="achievementsCtaContactPhone">537 240 394</span>
            </a>
            <a href="tel:601963996" className="achievementsCtaContact">
              <span className="achievementsCtaContactName">Trener Leszek</span>
              <span className="achievementsCtaContactPhone">601 963 996</span>
            </a>
            <a href="tel:535991986" className="achievementsCtaContact">
              <span className="achievementsCtaContactName">Trener Piotr</span>
              <span className="achievementsCtaContactPhone">535 991 986</span>
            </a>
            <a href="tel:730273580" className="achievementsCtaContact">
              <span className="achievementsCtaContactName">Trener Bartek</span>
              <span className="achievementsCtaContactPhone">730 273 580</span>
            </a>
            <a href="tel:789246311" className="achievementsCtaContact">
              <span className="achievementsCtaContactName">
                Trenerka Karolina
              </span>
              <span className="achievementsCtaContactPhone">789 246 311</span>
            </a>
          </div>
        </div>
      </section>

      {/* ── Lightbox modal ───────────────────────────── */}
      <Modal
        isOpen={openIdx !== null}
        onRequestClose={() => setOpenIdx(null)}
        onAfterOpen={() => {
          document.addEventListener("keydown", handleKeyDown);
          document.body.style.overflow = "hidden";
        }}
        onAfterClose={() => {
          document.removeEventListener("keydown", handleKeyDown);
          document.body.style.overflow = "";
        }}
        className="achievementsModal"
        overlayClassName="achievementsModalOverlay"
        ariaHideApp={false}>
        {openIdx !== null && (
          <>
            <button
              className="achievementsModalClose"
              onClick={() => setOpenIdx(null)}
              aria-label="Zamknij">
              ✕
            </button>
            <img
              src={photos[openIdx]}
              alt={`Osiągnięcia trenerów — ${openIdx + 1}`}
              className="achievementsModalImg"
            />
            <div className="achievementsModalCounter">
              {openIdx + 1} / {photos.length}
            </div>
            <button
              className="achievementsNavBtn achievementsNavBtnPrev"
              onClick={goPrev}
              aria-label="Poprzednie">
              ‹
            </button>
            <button
              className="achievementsNavBtn achievementsNavBtnNext"
              onClick={goNext}
              aria-label="Następne">
              ›
            </button>
          </>
        )}
      </Modal>
    </section>
  );
};

export default CoachesAchievements;
